import { Box, Text, useThemeUI } from "theme-ui";
import getFp from "lodash/fp/get";
import uniqBy from "lodash/fp/uniqBy";
import map from "lodash/fp/map";
import set from "lodash/fp/set";
import flow from "lodash/fp/flow";
import flatMap from "lodash/fp/flatMap";

import { Select } from "components";
import * as styles from "./DropDownWithDetails.styles";

export default function DropDownWithDetails({
  options = [],
  value: selectedValue = "",
  placeholder,
  onChange,
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const defaultDetails = flow(
    flatMap(getFp("details")),
    uniqBy("label"),
    map(set("value", "--"))
  )(options);

  const selectedOption = options.find(
    (option) => option.value === selectedValue
  );

  const details = selectedOption?.details || defaultDetails;

  return (
    <>
      <Box sx={styles.dropDown}>
        <Select
          variant="round"
          size={isMobile ? "medium" : "large"}
          value={selectedValue}
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
        >
          <option key="__blank" value="" disabled={selectedValue}>
            {placeholder || "Select"}
          </option>

          {options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
      </Box>

      {details.map(({ label, value }) => (
        <Text key={label} as="div" sx={styles.details}>
          {label}: {value}
        </Text>
      ))}
    </>
  );
}
